import {
  getAffiliateHierarchies,
  getAffiliateRelationshipTypes,
  getAffiliateRetirementTypes,
  getAffiliateTypes,
} from '@/services/affiliates.service';
import { queryDestinations } from '@/services/destinations.service';
import { orderBy } from 'lodash';

const initialState = {
  data: {},
  action: null,
  hierarchies: [],
  destinations: [],
  affiliateTypes: [],
  retirementsTypes: [],
  relationshipTypes: [],
  affiliateRetirementTypes: [],
  title: 'Cambiar estado afiliatorio',
};

const Model = {
  namespace: 'changeAffiliateStateModal',
  state: initialState,
  effects: {
    *setAction({ payload }, { put }) {
      yield put({
        type: 'save',
        payload,
      });
    },

    *clean({ payload }, { put }) {
      yield put({
        type: 'clear',
        payload,
      });
    },

    *fetchAffiliateTypes({ payload }, { call, put, all }) {
      const [
        affiliateTypes,
        affiliateRetirementTypes,
        hierarchies,
        retirementsTypes,
        relationshipTypes,
        destinations,
      ] = yield all([
        call(getAffiliateTypes, payload),
        call(getAffiliateRetirementTypes, payload),
        call(getAffiliateHierarchies, payload),
        call(getAffiliateRetirementTypes, payload),
        call(getAffiliateRelationshipTypes, payload),
        call(queryDestinations, payload),
      ]);

      yield put({
        type: 'save',
        payload: {
          hierarchies: orderBy(hierarchies.data, 'name'),
          destinations: orderBy(destinations.data, 'name'),
          affiliateTypes: orderBy(affiliateTypes, 'name'),
          retirementsTypes: orderBy(retirementsTypes.data, 'name'),
          relationshipTypes: orderBy(
            relationshipTypes.data.filter((rt) => rt.key !== 'ESTUDIANTE'),
            'name',
          ),
          affiliateRetirementTypes: orderBy(affiliateRetirementTypes.data, 'name'),
        },
      });
    },
  },

  reducers: {
    save(state, { payload }) {
      return { ...state, ...payload };
    },

    clear() {
      return initialState;
    },
  },
};
export default Model;
